<ng-container *transloco="let t">
    <app-nav-tabs [useRouterOutlet]="true" [queryParamsHandling]="'preserve'" [tabCssClass]="'nested'">
        <app-nav-tab [title]="t('league.management.tabs.results.round')" [itemId]="1" [route]="BY_ROUND">
        </app-nav-tab>
        <app-nav-tab [title]="t('league.management.tabs.results.overall')" [itemId]="2" [route]="OVERALL">
        </app-nav-tab>
    </app-nav-tabs>
</ng-container>